import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  filterModalContainer: {
    zIndex: `${theme.zIndex.inventory.filterModal} !important`,
  },
  filterModal: {
    [theme.breakpoints.up("md")]: {
      maxWidth: "90vw",
      width: 500,
    },
    display: "inline-flex",
  },
  formControl: {
    minWidth: "150px",
    maxWidth: "150px",
    [theme.breakpoints.down("md")]: {
      flex: "1 1 0px",
      paddingRight: 10,
    },
  },
  modalActions: {
    // Mobile only
    [theme.breakpoints.down("md")]: {
      justifyContent: "space-between",
    },
  },
  // So first item has the same padding as rest due to built in padding
  modalContents: {
    overflowX: "hidden",
    "& > h5:nth-of-type(1)": {
      paddingTop: 14,
    },
  },
  customSelect: {
    border: theme.shape.border,
    "& > select": {
      padding: "11px",
    },
  },
  unfocused: {
    color: theme.palette.content.tertiary,
  },
}));
